<script>
   import Layout from '../../layouts/main'
   import PageHeader from '@/components/page-header'
   import appConfig from "@/app.config";
   import moment from 'moment';
   import Vue from 'vue'
   // This variable will hold the reference to
   // document's click handler
   Vue.directive("click-outside", {
   bind(el, binding, vnode) {
      el.clickOutsideEvent = (event) => {
         if (!(el === event.target || el.contains(event.target))) {
         vnode.context[binding.expression](event);
         }
      };
      document.body.addEventListener("click", el.clickOutsideEvent);
   },
   unbind(el) {
      document.body.removeEventListener("click", el.clickOutsideEvent);
   },
   });
    
   export default {
      page: {
         title: "Add Consultation",
         meta: [
            {
               name: "description",
               content: appConfig.description,
            },
         ],
      },
      components: { Layout, PageHeader },
      data() {

         const current_date = moment().format("YYYY-MM-DD");
         const datetime_now = moment().format("YYYY-MM-DD HH:mm:ss");         
         const week_date = moment().add(2,'days').format("YYYY-MM-DD");
         return {
            title: "Add Consultation",
            items: [
               {
                  text: "Consultation",
                  href: "/consultations",
               },
               {
                  text: "Add Consultation",
                  active: true,
               },        
            ],


            clinic_slots: [],
            consultation: {
               booking_date: current_date,
               patient_id: null,
               consultation_for: "",
               consultation_through: '',
               member_id: '',
               doctor_id: '',
               clinic_id: '',
               type: '',
               video_slot_id: null,
               clinic_slot_id: null,
               clinic_slot: '',
               home_slot_id: null,
               amount: '',
               payment_id: '',
               payment_type: '',
            },

            patients: [],
            patient_visible: false,
            patient_keyword: '',
            patient_id: '',
            total_amount: '',

            doctor_error: '',

            doctors: [],
            doctor_visible: false,
            doctor_keyword: '',
            doctor_id: '',

            members: [],

            errors: {
               
            },

            now: datetime_now,
            today: current_date,
            week: week_date,

            clinic_fee: '',
            loading: false,

         };
      },
      mounted() {
         if(this.$route.params.id) {
            this.patient_keyword = this.$route.params.id;
            this.patient_id = this.$route.params.id;
         }
         if(this.$route.params.patient_id) {
            this.patient_id = this.$route.params.patient_id;
            this.fetchMembers();
         }
      },
      created() {
         this.setPatientId();
         // this.fetchClinicDoctors();
      },

      methods: {

         getToken() {
            if (localStorage.getItem('medicino_clinic')) {
               var medicino_clinic =  JSON.parse(localStorage.getItem('medicino_clinic'));
               if(medicino_clinic.token) {
                  this.token = medicino_clinic.token;
               } else {
                  this.$swal("", "Failed to fetch token, please login again", "error");
                  this.$router.push({ name: "login" });
               }
               
            } else {
               this.$swal("", "Session expired, please login again", "error");
               this.$router.push({ name: "login" });
            }
         },

         checkDoctor(){

         if (this.doctors.length === 1) {
               this.consultation.doctor_id = this.doctors[0].id;  
               this.doctor_keyword = this.doctors[0].name;   
               this.fetchClinicSchedule();
               this.fetchDoctorDetails();
               this.setDoctor();                                 
         } 

         },

         closePatientSearch() {
            this.patient_visible = false;
            this.patient_keyword = '';
            this.patient_id = '';
         },

         setPatientId() {
            if (this.$route.params.id) {
               this.consultation.patient_id = this.$route.params.id;
               this.consultation.doctor_id = this.$route.params.doctor_id;
               this.fetchPatients();
               this.fetchDoctorDetails();
            }
         }, 

         setPatient() {
            this.patient_keyword = event.target.options[event.target.options.selectedIndex].label;
            this.patient_visible = false;
            this.fetchMembers();
         },

         onClickOutside() {
            //console.log("clicked outside");
            if(!this.patient_id){
               this.patient_keyword = '';
               this.patient_visible = false;
            }
           
         },


         fetchClinicDoctors(){

            let url = "clinic/doctor/clinic?keyword=" + this.doctor_keyword;      
            this.getToken();
            this.$axios
            .get(url, { headers: { Authorization: "Bearer " + this.token } })
            .then((res) => {
               var responseData = res.data.data;
               this.doctors = responseData;
               this.doctor_visible = true;
                 this.justOpened = true;

                     // Focus the input after DOM update
                     this.$nextTick(() => {
                        this.$refs.doctorInput?.focus();
                     });

                     // Reset the outside click block after a short delay
                     setTimeout(() => {
                        this.justOpened = false;
                     }, 300);
               this.checkDoctor();
               // console.log(this.doctors);
               })
               .catch((err) => console.log(err));

         },


         fetchPatients() { 
            let url = "api/admin/pharmacy/orders/getpatients?keyword=" + this.patient_keyword;         
            this.getToken();
            this.$axios
               .get(url, { headers: { Authorization: "Bearer " + this.token } })
               .then((res) => {
                  var responseData = res.data.data;
                  // console.log(responseData);
                  this.patients = responseData.patients;
                  if (this.$route.params.id) {
                     this.setPatient();
                  }else{
                     this.patient_visible = true;

                      this.justOpened = true;

                     // Focus the input after DOM update
                     this.$nextTick(() => {
                        this.$refs.patientInput?.focus();
                     });

                     // Reset the outside click block after a short delay
                     setTimeout(() => {
                        this.justOpened = false;
                     }, 300);
                  }
               })
               .catch((err) => console.log(err));
         },


         closeDoctorSearch() {
            this.doctor_visible = false;
            this.doctor_keyword = '';
            this.consultation.doctor_id = '';
            this.consultation.amount = '';
            this.doctor_id = '';
            this.consultation.clinic_slot = '';
            this.consultation.clinic_slot_id = null;
            // console.log('keyworda', this.consultation.clinic_slot);
            // console.log('keyword', this.doctor_keyword);
            // console.log('doctor_id', this.consultation.doctor_id);
            this.clinic_slots = [];            
         },

         numbersOnly(event) {
            let keyCode = event.keyCode;
            if (keyCode < 48 || keyCode > 57) {
               event.preventDefault();
            }
         }, 

         setDoctor() {
            this.doctor_keyword = event.target.options[event.target.options.selectedIndex].label;
            this.doctor_visible = false;
         },

         
         fetchMembers() {  
         let url = "api/admin/consultations/getMembers?patient_id=" + this.patient_id;         
         this.getToken();
         this.$axios
            .get(url, { headers: { Authorization: "Bearer " + this.token } })
            .then((res) => {
               var responseData = res.data.data;
               // console.log(responseData);
               this.members = responseData.members;
               this.member_visible = true;
               
            })
            .catch((err) => console.log(err));
         },

         fetchSchedules() { 
            this.clearSlots();
            if(this.consultation.doctor_id && this.consultation.booking_date) {
               let url = "api/admin/consultations/getSchedules?doctor_id=" + this.consultation.doctor_id + "&date=" + this.consultation.booking_date;         
               this.getToken();
               this.$axios
                  .get(url, { headers: { Authorization: "Bearer " + this.token } })
                  .then((res) => {
                     var responseData = res.data.data;
                     // console.log(responseData);

                     // this.clinic_schedules = responseData.clinic_schedules;
                     // this.clinic_slots = responseData.clinic_slots[0];

                     this.home_schedules = responseData.home_schedules;
                     this.home_slots = responseData.home_slots[0];

                     this.video_schedules = responseData.video_schedules;
                     this.video_slots = responseData.video_slots[0];

                     this.video_charge = responseData.video_charge;
                     this.home_charge = responseData.home_charge;
                     this.clinic_charge = responseData.clinic_charge;


                     // if booking date is current date, display time slots only after the current time starts here
                     // var now_plus_one = moment().add(1,'hours').format("YYYY-MM-DD HH:mm:ss");
                     var now_plus_five = moment().add(5,'minutes').format("YYYY-MM-DD HH:mm:ss");
                     // var now_plus_one1 = moment().format("YYYY-MM-DD HH:mm:ss");


                     if(this.consultation.booking_date==this.today) {
                        for(var i=0; i<this.video_slots.length; i++) {
                           var start_time = this.consultation.booking_date + " " + this.video_slots[i].start;
                           if(start_time <= now_plus_five) {
                              this.video_slots[i].dnone = true;
                           }
                        }

                        for(i=0; i<this.home_slots.length; i++) {
                           start_time = this.consultation.booking_date + " " + this.home_slots[i].start;
                           if(start_time <= now_plus_five) {
                              this.home_slots[i].dnone = true;
                           }
                        }

                        for(i=0; i<this.clinic_slots.length; i++) {
                           start_time = this.consultation.booking_date + " " + this.clinic_slots[i].start;
                           if(start_time <= now_plus_five) {
                              this.clinic_slots[i].dnone = true;
                           }
                        }
                     } // ends here

                     // console.log(this.video_slots);
                     
                  })
                  .catch((err) => console.log(err));
            } if(this.consultation.doctor_id && this.consultation.booking_date && this.consultation.consultation_through == 1) {

               let url = "api/admin/consultations/doctor_clinics?doctor_id=" +this.consultation.doctor_id;        
              this.getToken();
              this.$axios
                 .get(url, { headers: { Authorization: "Bearer " + this.token } })
                 .then((res) => {
                    var responseData = res.data.data;
                  //   console.log(responseData);
                    this.clinics = responseData.clinics;
                 })
                 .catch((err) => console.log(err));
            }
            this.fetchClinicSchedule();
            
         },

         fetchDoctorDetails() { 
            let url = "api/admin/doctors/details?doctor_id=" + this.consultation.doctor_id;         
            this.getToken();
            this.$axios
               .get(url, { headers: { Authorization: "Bearer " + this.token } })
               .then((res) => {
                  var responseData = res.data.data;
                  // console.log(responseData);
                  this.no_days = responseData.doctor.no_days_booking;
                  this.week = moment().add(this.no_days, 'days').format("YYYY-MM-DD");
               })
               .catch((err) => console.log(err));
            
         },

         fetchClinicSchedule() { 
            // this.clearSlots();
            if(this.consultation.doctor_id && this.consultation.booking_date) {
               let url = "clinic/consultation/clinic_scheduleNew?doctor_id=" + this.consultation.doctor_id + "&date=" + this.consultation.booking_date;         
               this.getToken();
               this.$axios
                  .get(url, { headers: { Authorization: "Bearer " + this.token } })
                  .then((res) => {
                     var responseData = res.data.data;
                     console.log(responseData);

                     this.clinic_schedules = responseData.clinic_schedules;
                     this.clinic_slots = responseData.clinic_slots[0];
                     // console.log(this.clinic_slots);
                     this.clinic_charge = responseData.clinic_charge;
                     this.clinic_fee = responseData.clinic_fee;
                     this.consultation.amount = responseData.convenience_fee;

                     this.total_amount = parseFloat(this.consultation.amount) + parseFloat(this.clinic_fee);

                     // if booking date is current date, display time slots only after the current time starts here
                     // var now_plus_one1 = moment().add(1,'hours').format("YYYY-MM-DD HH:mm:ss");
                     var now_plus_one1 = moment().format("YYYY-MM-DD HH:mm:ss");

                     if(this.consultation.booking_date==this.today) {

                        for(var j=0; j<this.clinic_slots.length; j++) {
                           var start_time1 = this.consultation.booking_date + " " + this.clinic_slots[j].start;
                           if(start_time1 <= now_plus_one1) {
                              this.clinic_slots[j].dnone = true;
                           }
                        }
                     } // ends here
                  })
                  .catch((err) => console.log(err));
            } 
            
         },

         addConsultation(shouldPrint = false) {
            console.log(shouldPrint);
            if(this.patient_id && !this.clinic_slots.length && this.consultation.doctor_id && this.consultation.booking_date){
               this.$swal("", "No slots available", "error");
               this.errors = {};            
            }else{
               if(this.patient_visible){
                  this.patient_id = '';
               }
               if(this.doctor_visible){
                  this.doctor_id = '';
               }

               // console.log(this.consultation.clinic_slot);

               let slot = ''; 

               if(this.consultation.clinic_slot) {
                  slot = this.consultation.clinic_slot.split("-"); 
                  this.consultation.day_id = this.clinic_schedules[0][0].day_id;
               }

               if(slot) {
                  this.consultation.start_time = slot[0];
                  this.consultation.end_time = slot[1];
                  this.consultation.doctor_session_id = slot[2];
                  this.consultation.token = slot[3];
                  this.consultation.schedule_start = slot[4];
                  this.consultation.schedule_end = slot[5];
               }

               // console.log(slot);
               // console.log(this.consultation.day_id);

               this.getToken();           
               
               const config = {
                  headers: {
                     "Content-type": "multipart/form-data",
                     "Accept": "application/json",
                     "Authorization": "Bearer " + this.token,
                  },
               };

               let url = "clinic/consultation/add";  
         
               let formData = new FormData();
               formData.append("patient_id", this.patient_id); 
               formData.append("member_id", this.consultation.consultation_for); 
               //formData.append("clinic_id", this.consultation.clinic_id); 
               if(this.doctor_keyword != ''){
                  formData.append("doctor_id", this.consultation.doctor_id); 
               }
               formData.append("session_id", this.consultation.doctor_session_id); 
               formData.append("booking_date", this.consultation.booking_date); 
               formData.append("consultation_start_time", this.consultation.start_time);
               formData.append("consultation_end_time", this.consultation.end_time); 
               formData.append("schedule_start", this.consultation.schedule_start); 
               formData.append("schedule_end", this.consultation.schedule_end); 
               formData.append("payment_type", this.consultation.payment_type); 
               formData.append("payment_id", this.consultation.payment_id); 
               formData.append("amount", this.consultation.amount); 
               formData.append("day_id", this.consultation.day_id); 
               formData.append("token", this.consultation.token); 
               formData.append("consultation_fee", this.clinic_fee); 
               
               this.loading = true;

               this.$axios
               .post(url, formData, config)
               .then((response) => {
                     if (response.data.status) {
                        this.$swal("", response.data.message, "success");
                        console.log(response);
                        if(response.status == 200){
                           if(shouldPrint){
                              const url = "api/downloadToken?booking_id=" + response.data.data.booking_id;
                                 this.getToken();
                                 this.$axios
                                    .get(url, {
                                       headers: { Authorization: "Bearer " + this.token },
                                       responseType: "blob"
                                    })
                                    .then(res => {
                                       const blob = new Blob([res.data], { type: "application/pdf" });
                                       const blobUrl = URL.createObjectURL(blob);

                                       // Open the PDF in a new window/tab
                                       const printWindow = window.open(blobUrl, '_blank');
                                       
                                       // Wait until the PDF loads, then trigger print
                                       printWindow.onload = () => {
                                       printWindow.focus();
                                       printWindow.print();
                                       };

                                       // Optional: revoke URL after some time
                                       setTimeout(() => {
                                       URL.revokeObjectURL(blobUrl);
                                       }, 5000);
                                    })
                                    .catch(error => {
                                       console.error("Error printing PDF:", error);
                                       const reader = new FileReader();
                                       reader.onload = (event) => {
                                       const text = event.target.result;
                                       const errorData = JSON.parse(text);
                                       const errorMessage = errorData.message;
                                       if (errorMessage) {
                                          this.errors = errorMessage;
                                       } else {
                                          this.$swal("", "Failed to load PDF for printing", "error");
                                       }
                                       };
                                       reader.readAsText(error.response.data);
                                    });
                                 this.$router.push({ name: 'consultations'});

                           }else{
                           this.$router.push({ name: 'consultations'}); 
                           }
                        }

                     } else {
                        this.$swal("", response.data.message, "error");
                     }
                  })
                  .catch((error) => {
                     // console.log(error.response);
                     if (error.response) {
                        if (error.response.data.message) {
                           if(error.response.status == 422) {
                              // this.$set(this, 'errors', error.response.data.message);
                              this.errors = error.response.data.message;
                              if(error.response.status == 422);{
                                 this.$nextTick(() => {
                                    const firstErrorField = document.querySelector('.is-invalid');
                                    if (firstErrorField) {
                                       firstErrorField.scrollIntoView({ behavior: 'smooth', block: 'center' });
                                       firstErrorField.focus();
                                    }
                                 });
                              }
                              console.log(this.errors);

                           } else {
                              this.$swal("", error.response.data.message, "error");
                           }
                        } else {
                           this.$swal("", "Something went wrong", "error");
                        }
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  })
                  .finally(() => (this.loading = false));
               }
         },
         
         rescheduleConsultation(){


            if(this.patient_visible){
               this.patient_id = '';
            }
            if(this.doctor_visible){
               this.doctor_id = '';
            }

            // console.log(this.consultation.clinic_slot);

            let slot = ''; 

            if(this.consultation.clinic_slot) {
               slot = this.consultation.clinic_slot.split("-"); 
               this.consultation.day_id = this.clinic_schedules[0][0].day_id;
            }

            if(slot) {
               this.consultation.start_time = slot[0];
               this.consultation.end_time = slot[1];
               this.consultation.doctor_session_id = slot[2];
               this.consultation.token = slot[3];
            }

            // console.log(slot);
            // console.log(this.consultation.day_id);
            this.getToken();           
            
            const config = {
               headers: {
                  "Content-type": "multipart/form-data",
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };

            let url = "clinic/consultation/reschedule";  
       
            let formData = new FormData();

            formData.append("id", this.$route.params.id); 
            formData.append("session_id", this.consultation.doctor_session_id);
            //formData.append("consultation_type", this.$route.params.type); 
            formData.append("booking_date", this.consultation.booking_date); 
            formData.append("consultation_start_time", this.consultation.start_time);
            formData.append("consultation_end_time", this.consultation.end_time); 
            formData.append("day_id", this.consultation.day_id); 
            formData.append("token", this.consultation.token); 
            
            this.loading = true;
            
            this.$axios
            .post(url, formData, config)
            .then((response) => {
                  if (response.data.status) {
                     this.$swal("", response.data.message, "success");
                  } else {
                     this.$swal("", response.data.message, "error");
                  }
                  this.$router.push({ name: 'consultations'});
               })
               .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {

                        if(error.response.status == 422) {
                           this.errors = error.response.data.message;
                        } else {
                           this.$swal("", error.response.data.message, "error");
                        }
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               })
               .finally(() => (this.loading = false));

         },

         doConsultation(shouldPrint = false){

         if(this.$route.params.id) {
            this.rescheduleConsultation(shouldPrint);
         }else{
            this.addConsultation(shouldPrint);
         }

         },

         clearThrough() {

            if(this.consultation.consultation_through == 2) {
               this.consultation.type = 'clinic';
            } else {
               this.consultation.type = '';
            }
            this.consultation.doctor_id = '';
            this.consultation.clinic_id = '';
            this.consultation.booking_date = '';            
            
            this.consultation.video_slot_id = null;
            this.consultation.clinic_slot_id = null;
            this.consultation.home_slot_id = null;
            this.closeDoctorSearch();
         },

         clearSlots() {
            this.consultation.video_slot_id = null;
            this.consultation.home_slot_id = null;
            this.consultation.clinic_slot_id = null;
         },
      }
   }
</script>

<style type="text/css">
   .slots label.btn {
      border-radius: 5px !important;
      margin-right: 10px;
      margin-bottom: 10px;
   }

   .slots {
      display: inline;
   }

     .token-badge {
      display: inline-block;
      background-color: #28a745;
      color: white;
      padding: 3px 12px;
      border-radius: 50px;
      font-size: 12px;
      font-weight: 600;
      margin-left: 8px;
      white-space: nowrap;
      vertical-align: middle;
      line-height: 1;
   }

   .slots label.btn .token-badge {
      background-color: #17a2b8;
   }

   .slots label.btn.active .token-badge {
      background-color: #ffc107;
      color: #000;
   }

   .slots label.btn:disabled .token-badge {
      background-color: #6c757d;
      opacity: 0.6;
   }

   /* Clinic slot token types */
   .slots label.btn .token-badge.token-type-1 {
      background-color: rgba(255, 87, 34, 0.10);  /* Light orange for token_type 1 */
      color: #ff5722;
   }

   .slots label.btn .token-badge.token-type-2 {
      background-color: rgba(139, 195, 74, 0.15);  /* Light green for token_type 2 */
      color: #8bc34a;
   }

   .slots label.btn.active .token-badge.token-type-1 {
      background-color: rgba(255, 87, 34, 0.20);  /* Slightly darker orange when selected */
      color: #ff5722;
   }

   .slots label.btn.active .token-badge.token-type-2 {
      background-color: rgba(139, 195, 74, 0.25);  /* Slightly darker green when selected */
      color: #8bc34a;
   }

   .slots label.btn:disabled .token-badge.token-type-1,
   .slots label.btn:disabled .token-badge.token-type-2 {
      background-color: #6c757d;
      opacity: 0.6;
   }

   /* Color Legend */
   .color-legend {
      display: flex;
      gap: 20px;
      margin-top: 10px;
      padding: 10px 0;
   }

   .legend-item {
      display: flex;
      align-items: center;
      gap: 8px;
   }

   .legend-color {
      width: 16px;
      height: 16px;
      border-radius: 50%;
      display: inline-block;
   }

   .legend-color.green {
      background-color: #ff5722;  /* Orange for In App & TVM */
   }

   .legend-color.red {
      background-color: #8bc34a;  /* Green for TVM */
   }

   .legend-text {
      font-size: 14px;
      font-weight: 500;
      color: #333;
   }
</style>
    
<template>
   <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
         <div class="col-12">
            <div class="card">
               <div class="card-body">

                  <!----- top button area starts---->
                  <div class="row mb-2">
                     <div class="col-12">
                        <router-link :to="{ name: 'consultations' }" class="btn btn-primary float-end ms-2">
                           <i class='bx bx-chevrons-left'></i> Back
                           </router-link>
                           <router-link :to="{ name: 'patients.add' }" class="btn btn-primary float-end">
                           Add Patient
                           </router-link>
                     </div>
                  </div>
                  <!----- top button area ends---->
                  <b-card header-class="bg-transparent border-light" class="border border-light">
                     <!-- <form class="form-horizontal" role="form" @submit.prevent="doConsultation()"> -->
                     <form class="form-horizontal" role="form">

                        <div class="row mb-3">
                           <div class="form-group col-md-6" v-if="!$route.params.patient_id && !$route.params.id"  v-click-outside="onClickOutside">
                              <label>Patient <span class="text-danger">*</span></label>
                                 <div class="search-select">
                                 <span class="search-close" v-if="patient_visible" @click="closePatientSearch">
                                    <i class="dripicons dripicons-cross"></i>
                                 </span>

                                 <b-form-input ref="patientInput"
                                    v-model="patient_keyword"
                                    @keyup="fetchPatients()"
                                    @click="fetchPatients()"
                                    autocomplete="off"
                                    placeholder="Search here..."
                                    v-bind:class="{ 'is-invalid': Boolean(errors.patient_id) }"
                                 ></b-form-input>

                                 <b-form-select
                                    class="form-control"
                                    v-if="patient_visible && Boolean(patients.length)"
                                    v-model="patient_id"
                                    :select-size="patients.length < 10 ? (patients.length <= 1 ? 2 : patients.length) : 10"
                                    @change="setPatient(); fetchClinicDoctors()"
                                 >
                                    <b-form-select-option
                                       v-for="patient in patients"
                                       :key="patient.patient_id"
                                       :value="patient.patient_id"
                                    >
                                       {{ patient.country_code }} {{ patient.mobile }} | {{ patient.name }}
                                    </b-form-select-option>
                                 </b-form-select>

                                 <b-form-select class="form-control" v-if="patient_visible && !Boolean(patients.length)" v-model="patient_id" :select-size="2">
                                    <b-form-select-option :value="0" disabled>No data results...</b-form-select-option>
                                 </b-form-select>

                                 <!-- Error message block -->
                                 <div v-for="(val, index) in errors.patient_id" :key="index" class="invalid-feedback">
                                       <p class="mb-0">{{ val }}</p>
                                 </div>
                                 </div>
                           </div>   

                           <div class="form-group col-md-6" v-if="!$route.params.id">
                              <label>Consultation For <span class="text-danger">*</span></label>
                              <select class="form-control" v-model="consultation.consultation_for" v-bind:class="{ 'is-invalid': Boolean(errors.consultation_for) }">
                                 <option value="">Self</option>
                                 <option :value="member.id" v-for="member in members" :key="member.id">{{member.name}}</option>
                              </select>
                           </div>

                           <!-- <div class="form-group col-md-6" v-if="consultation.consultation_for==2">
                              <label>Member <span class="text-danger">*</span></label>
                              <select class="form-control" v-model="consultation.member_id" v-bind:class="{ 'is-invalid': Boolean(errors.member_id) }">
                                 <option value="">Select</option>
                                 <option value="1">Member 1</option>
                                 <option value="2">Member 2</option>
                                 <option value="3">Member 3</option>
                                 <option value="4">Member 4</option>
                                 <option value="5">Member 5</option>
                              </select>
                           </div> -->
                           <div class="form-group col-md-6" v-if="!$route.params.id"  v-bind:class="{ 'is-invalid': Boolean(errors.doctor_id) }">
                              <label>Doctor <span class="text-danger">*</span></label>
                              <div class="search-select">
                                 <span class="search-close" v-if="doctor_visible" @click="closeDoctorSearch"><i class="dripicons dripicons-cross"></i></span>
                                       
                                 <b-form-input ref="doctorInput" v-model="doctor_keyword"  @keyup="fetchClinicDoctors()" @click="fetchClinicDoctors()" autocomplete="off" placeholder="Search here..." v-bind:class="{ 'is-invalid': Boolean(errors.doctor_id) }"></b-form-input>
                                 
                                 <b-form-select class="form-control" v-if="doctor_visible && doctors.length > 1" v-model="consultation.doctor_id" :select-size="doctors.length < 10 ? (doctors.length <= 1 ? 2 : doctors.length) : 10" @change="setDoctor(); fetchClinicSchedule()||fetchDoctorDetails()">
                                    <b-form-select-option v-for="doctor in doctors" :key="doctor.doctor_id" :value="doctor.doctor_id">{{ doctor.prefix }}{{ doctor.name }} </b-form-select-option>
                                 </b-form-select>

                                 <b-form-select class="form-control" v-if="doctor_visible && !Boolean(doctors.length)" v-model="doctor_id" :select-size="2">                  
                                       <b-form-select-option :value="0" disabled>No data results...</b-form-select-option>
                                 </b-form-select>
                                 <div v-for="(val, index) in errors.doctor_id" :key="index" class="invalid-feedback">
                                    <p class="mb-0">{{ val }}</p>
                                 </div>
                              </div>
                           </div>

                           <div class="form-group col-md-6" v-if="consultation.doctor_id||$route.params.id">
                              <label>Date <span class="text-danger">*</span></label>
                              <input type="date" class="form-control" @change="fetchClinicSchedule()" v-model="consultation.booking_date" v-bind:class="{ 'is-invalid': Boolean(errors.date) }" :min="today" :max="week" />
                              
                              <div v-for="(val, index) in errors.booking_date" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </div>  
                        </div>

                        <b-card v-if="consultation.doctor_id && consultation.booking_date" header-class="bg-transparent border-light" class="border border-light">
                           <div class="row" >
                              <div class="col-12">
                                    <div class="form-group col-md-6" >
                                      
                                    </div> 

                                    <div class="row">
                                       <div class="form-group col-md-4">                        
                                          <label class="text-success"><b>Consultation Fee : ₹ {{ this.clinic_fee }}</b></label>   
                                       </div> 

                                       <div class="form-group col-md-4">                        
                                          <label class="text-success"><b>Convenience Fee : ₹ {{ this.consultation.amount }}</b></label>   
                                       </div>  

                                       <div class="form-group col-md-4">                        
                                          <label class="text-danger bg" style="font-size: 15px;"><b>Total Fee: ₹ {{ parseFloat(consultation.amount) + parseFloat(clinic_fee) }}</b></label>
                                       </div>  
                                    </div>

                                      <!-- Color Legend for Clinic Slots -->
                                    <div class="row">
                                       <div class="col-12">
                                          <div class="color-legend">
                                             <span class="legend-item">
                                                <span class="legend-color green"></span>
                                                <span class="legend-text">Patient App & Token Vending Machine</span>
                                             </span>
                                             <span class="legend-item">
                                                <span class="legend-color red"></span>
                                                <span class="legend-text">Token Vending Machine</span>
                                             </span>
                                          </div>
                                       </div>
                                    </div>

                                    <div class="w-100" v-if="clinic_slots.length">     

                                       <label class="w-100">Pick your slot <span class="text-danger">*</span></label>
                                       <b-form-radio-group 
                                          v-model="consultation.clinic_slot"
                                          name="clinic_slot"
                                          buttons
                                          button-variant="outline-primary"
                                          size="sm"
                                          class="slots"
                                          v-bind:class="{ 'is-invalid': Boolean(errors.session_id) }"
                                       >  
                                           <!-- <b-form-radio v-for="(slot, index) in clinic_slots" :key="index" :value="slot.start + '-' + slot.stop + '-' + slot.schedule_id + '-' + slot.token + '-' + slot.schedule_start + '-' + slot.schedule_end"  :disabled="!slot.slot_available || slot.dnone">{{slot.start | formatTime}} - {{slot.stop | formatTime}}</b-form-radio>  ----->
                                          <b-form-radio v-for="(slot, index) in clinic_slots" :key="index" :value="slot.start + '-' + slot.stop + '-' + slot.schedule_id + '-' + slot.token + '-' + slot.schedule_start + '-' + slot.schedule_end + '-'  "  :disabled="!slot.slot_available || slot.dnone">{{slot.start | formatTime}} - {{slot.stop | formatTime}} <span class="token-badge" :class="{'token-type-1': slot.token_type == 1, 'token-type-2': slot.token_type == 2}">{{slot.token}}</span></b-form-radio>  

                                       </b-form-radio-group>
                                       <div v-for="(val, index) in errors.session_id" :key="index" class="invalid-feedback">
                                          <p class="mb-0">{{ val }}</p>
                                       </div>
                                    </div>
                                    <div v-else>
                                       <p class="text-danger">No available slots</p>
                                    </div>
                              </div>
                           </div>


                           
                        </b-card>

                        <b-card v-if="consultation.clinic_slot" header-class="bg-transparent border-light" class="border border-light">
                           <h4 class="font-size-18 border border-top-0 border-start-0 border-end-0 pb-3 mb-3">
                              Payment Details                       
                              
                           </h4>

                           <div class="row">
                              <div class="form-group col-md-4">
                                 <label>Payment Type <span class="text-danger">*</span></label>
                                 <select class="form-control" v-model="consultation.payment_type"  v-bind:class="{ 'is-invalid': Boolean(errors.payment_type) }">
                                       <option value="">Select</option>
                                       <option value="Cash">Cash</option>
                                       <option value="Card">Card</option>
                                       <option value="Internet Banking">Internet Banking</option>
                                       <option value="GPay">GPay</option>
                                       <option value="Other UPI">Other UPI</option>
                                 </select> 

                                 <div v-for="(val, index) in errors.payment_type" :key="index" class="invalid-feedback">
                                    <p class="mb-0">{{ val }}</p>
                                 </div>   
                              </div>
                              
                              <div class="form-group col-md-4">
                                 <label>Payment ID <span v-if="consultation.payment_type!='Cash'" class="text-danger">*</span></label>
                                 <input type="text" v-model="consultation.payment_id" v-bind:class="{ 'is-invalid': Boolean(errors.payment_id) }" class="form-control"/>

                                 <div v-if="errors.payment_id && errors.payment_id.length" class="invalid-feedback">
                                    <p v-for="(val, index) in errors.payment_id" :key="index" class="mb-0">{{ val }}</p>
                                 </div> 
                              </div>

                              <div class="form-group col-md-4" v-if="consultation.payment_id">
                                 <label>Amount <span class="text-danger">*</span></label>
                                 <b-input-group size="sm" prepend="Rs.">
                                    <input type="text" v-model="total_amount" v-bind:class="{ 'is-invalid': Boolean(errors.amount) }" @keypress="numbersOnly" class="form-control" />

                                    <div v-if="errors.amount && errors.amount.length" class="invalid-feedback">
                                       <p v-for="(val, index) in errors.amount" :key="index" class="mb-0">{{ val }}</p>
                                    </div> 
                                 </b-input-group> 
                              </div>
                           </div>
                        </b-card>
                        

                        <div class="page-loader" v-if="!loading">
                           <div class="12">
                              <!-- <button class="btn btn-primary me-2" type="submit">Save</button> -->
                                <button class="btn btn-primary me-2"  @click.prevent="doConsultation(true)">Save & Print</button>
                                <button class="btn btn-primary me-2" @click.prevent="doConsultation(false)">Save</button>
                              <router-link :to="{ name: 'consultations' }" class="btn btn-light">Cancel</router-link>
                           </div>
                        </div>
                        <div class="page-loader" v-else>
                           <img src="@/assets/images/preloaderspin.gif"/>
                        </div>
                     </form>
                  </b-card>
               </div>
            </div>
         </div>
      </div>
   </Layout>
</template>
